import React from 'react';
import { Box, Typography } from '@mui/material';
import useOrientation from './useOrientation';
import { ScreenRotationAltOutlined } from '@mui/icons-material';
import { MdOutlineScreenLockRotation } from 'react-icons/md';

const OrientationWarningOverlay = () => {
  const { isPortrait, isMobile } = useOrientation();

  if (!(isMobile && isPortrait)) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        minWidth: '100%',
        minHeight: '100%',
        bgcolor: 'rgba(0,0,0,0.9)',
        color: '#fff',
        zIndex: 10000,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        p: 2,
        boxSizing: 'border-box', // Ensures padding doesn't cause overflow
        overflow: 'hidden' // Prevents any content from spilling out
      }}
    >
      <Box
        sx={{
          fontSize: 100,
          mb: 2,
          animation: 'rotateIcon 2s infinite',
          '@keyframes rotateIcon': {
            '0%': { transform: 'rotate(0deg)' },
            '100%': { transform: 'rotate(360deg)' }
          }
        }}
      >
        <MdOutlineScreenLockRotation />
      </Box>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Please Rotate Your Device
      </Typography>
      <Typography variant="body1">This feature works best in landscape mode. Rotate your mobile device to continue.</Typography>
    </Box>
  );
};

export default OrientationWarningOverlay;
